import styled from 'styled-components';

export const NightsCountWrapper = styled.div<{ periodType?: boolean }>`
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 26px;
  border-radius: 8px;
  background-color: ${({ periodType, theme }) =>
    periodType ? theme.palette.white : theme.palette.NL20};
  width: max-content;
`;
